import React from 'react';
import {GatewayGetSchema} from '../../../../api/DBSchema/Gateway';
import BaseCliScript4 from '../../AbstractObjects/GatewayPlan/InnerPages/BaseCliScript4';

const pageSchema = GatewayGetSchema.pages.cliScript4;
const pageId = pageSchema.pageId;

function PlanCliScript4({
    planObject,
    setPlanData
}) {

    let pageData = planObject[pageId];
    
    return (
        <BaseCliScript4
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanCliScript4;